 
import React from 'react';

interface ICloseProps {
    width?: number | string;
    height?: number | string;
}

const Close: React.FC<ICloseProps> = ({width = 20, height = 20}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.51953 3.51855L16.4832 16.4822"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M16.4805 3.51855L3.51684 16.4822"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Close;